import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouteLink } from 'react-router-dom';
import { stringify } from 'query-string';
import { isString, isObject } from 'lodash';
import clxBind from 'classnames/bind';
import Icon from '../Icon';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Link extends React.Component {
  static propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    external: PropTypes.bool,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    vAlign: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.any,
  };

  static defaultProps = {
    external: false,
    disabled: false,
    icon: undefined,
    vAlign: undefined,
    onClick: undefined,
    className: undefined,
    children: null,
  };

  static getHref(url) {
    const parser = document.createElement('a');
    parser.href = url;
    return parser.href;
  }

  static appendQuery(pathname, query) {
    const sep = pathname.includes('?') ? '&' : '?';
    return `${pathname}${sep}${stringify(query)}`;
  }

  static isInternal(to) {
    if (!to) {
      return false;
    }

    const pathname = isString(to) ? to : to.pathname;

    const host = `${window.location.protocol}//${window.location.host}`;
    const href = Link.getHref(pathname);

    return href.startsWith(host);
  }

  constructor(props) {
    super(props);

    this.state = {
      isInternal: Link.isInternal(props.to),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.to !== this.props.to) {
      const isInternal = Link.isInternal(this.props.to);
      this.setState({ isInternal });
    }
  }

  render() {
    const {
      to,
      icon,
      external,
      disabled,
      vAlign,
      onClick,
      className,
      children,
      ...props
    } = this.props;

    let iconElement;
    let childElement;

    const iconClasses = clx('icon', {
      [`v-align-${vAlign}`]: vAlign,
    });

    const contentClasses = clx('content', {
      [`v-align-${vAlign}`]: vAlign,
    });

    if (icon) {
      iconElement = <Icon icon={icon} className={iconClasses} />;
    }

    if (!children || isObject(children)) {
      childElement = children;
    } else {
      childElement = <span className={contentClasses}>{children}</span>;
    }

    const linkClasses = clx({ disabled, link: !className }, className);

    if (disabled || !to) {
      return (
        <span className={linkClasses} {...props}>
          {iconElement}
          {childElement}
        </span>
      );
    }

    if (external || !this.state.isInternal) {
      const pathname = !isString(to) ? Link.appendQuery(to.pathname, to.query) : to;

      return (
        <a href={pathname} onClick={onClick} className={linkClasses} {...props}>
          {iconElement}
          {childElement}
        </a>
      );
    }

    return (
      <RouteLink to={to} onClick={onClick} className={linkClasses} {...props}>
        {iconElement}
        {childElement}
      </RouteLink>
    );
  }
}
